var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
      {
        'adv-cart-product-list': true,
        'is-minicart': _vm.miniCart,
        'is-cart': !_vm.miniCart
      }
    ]},_vm._l((_vm.cartProductContents),function(cartProduct,index){return _c('adv-cart-product-row',{key:index,attrs:{"hasDuplicateSignature":_vm.hasDuplicateSignature(cartProduct),"mini-cart":_vm.miniCart,"read-only":_vm.readOnly,"disable-product-links":_vm.disableProductLinks,"cart-product":cartProduct}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }